export enum ActionSelectedBikes {
  MOVE = 1,
  DELETE = 2,
}
